const ADMIN_ROUTE_PREFIXES = new Set([
  'admin',
  'availability-management',
  'bookings-management',
  'order-management',
  'my-tasks',
  'services-management',
  'staff-management',
  'workflow-management',
  'accept-invite',
  'track',
  'terms-of-service',
  'privacy-policy'
]);

export const getCompanyScopeFromPath = (pathname = '') => {
  const [firstSegment] = pathname.split('/').filter(Boolean);

  if (!firstSegment || ADMIN_ROUTE_PREFIXES.has(firstSegment)) {
    return 'global';
  }

  return firstSegment;
};

export const getCompanyScopedStorageKey = (namespace, pathname = '') => (
  `clawfe:${namespace}:${getCompanyScopeFromPath(pathname)}`
);
